import { Markdown } from "@/components/Markdown";

export function TableBlock({ props, body }: { props: Record<string, unknown>; body: string }) {
  const header = Array.isArray(props.header) ? (props.header as unknown[]).map(String) : null;
  const rows = Array.isArray(props.rows) ? (props.rows as unknown[][]).map((r) => (Array.isArray(r) ? r.map(String) : [String(r)])) : null;

  if (!header && !rows) {
    // The server did not pre-parse; let GFM render the body.
    return <Markdown compact>{body}</Markdown>;
  }

  return (
    <div className="overflow-x-auto rounded-xl border bg-card">
      <table className="w-full border-collapse text-[0.925rem]">
        {header && header.length > 0 && (
          <thead>
            <tr>
              {header.map((h, i) => (
                <th key={i} className="border-b bg-muted/50 px-3.5 py-2 text-left font-semibold">
                  <Markdown inline>{h}</Markdown>
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {(rows ?? []).map((r, i) => (
            <tr key={i} className="border-b last:border-b-0">
              {r.map((c, j) => (
                <td key={j} className="px-3.5 py-2 align-top">
                  <Markdown inline>{c}</Markdown>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
